interface Props {
    children: React.ReactNode;
}

export const Upper = ({ children }: Props): React.ReactElement<any, any> | null => (
    // text-first-upper, will only work on block elements
    // if you can't use a block element use lodash's "capitalize" function.
    <div className="text-first-upper">{children}</div>
);
